import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

const DEFAULT_FILTERS = {
  uuid_allotment: '',
  uuid_subcontractor: '',
  status: '',
  contract_number: '',
  subscriber_name: '',
};

const useProjectFiltersStore = create(
  persist(
    (set, get) => ({
      filters: { ...DEFAULT_FILTERS },
      appliedFilters: { ...DEFAULT_FILTERS },

      setFilter: (name, value) => {
        set((state) => ({
          filters: {
            ...state.filters,
            [name]: value,
          },
        }));
      },

      applyFilters: () => {
        set((state) => ({
          appliedFilters: { ...state.filters },
        }));
      },

      clearFilters: () => {
        set({
          filters: { ...DEFAULT_FILTERS },
          appliedFilters: { ...DEFAULT_FILTERS },
        });
      },

      getFilters: () => get().filters,
    }),
    {
      name: 'persist:project-filters',
      version: 1,
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useProjectFiltersStore;
